module.exports = __webpack_public_path__ + "img/Weapon_144.717c78ee.png";